import { useState, useCallback } from 'react';
import { FiCopy } from 'react-icons/fi';
import { BsPatchCheckFill } from 'react-icons/bs';

const COPIED_RESET_MS = 2000;

interface Props {
  value: string;
  children?: React.ReactNode;
}

const CopyableCell: React.FC<Props> = ({ value, children }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      if (value) {
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), COPIED_RESET_MS);
      }
    },
    [value],
  );

  const handleContextMenu = (e: React.MouseEvent) => {
    if (!value) return;
    e.preventDefault();
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), COPIED_RESET_MS);
  };

  const hasValue = Boolean(value);

  return (
    <div
      className={`xa-grid-copyable-cell${hasValue ? ' xa-grid-copyable-cell--has-value' : ''}`}
      onContextMenu={handleContextMenu}
      title={hasValue ? 'Right click to copy' : undefined}
    >
      <div className="xa-grid-copyable-cell-value">
        {children ?? value}
      </div>
      {hasValue && (
        <>
          {copied && (
            <span className="xa-grid-copyable-cell-copied">Copied!</span>
          )}
          <button
            type="button"
            className="xa-grid-copyable-cell-btn"
            onClick={handleCopy}
            title="Copy"
            aria-label="Copy"
          >
            {copied ? (
              <BsPatchCheckFill className="xa-grid-copyable-cell-btn-check" />
            ) : (
              <FiCopy />
            )}
          </button>
        </>
      )}
    </div>
  );
};

export default CopyableCell;
